<template>
    <div v-loading="loading" class="contentBody">
        <div v-if="text" v-html="text" style="text-align: left;"></div>
        <div v-if="!text && !loading">
            <el-row align="middle">
                <el-col :span="10" style="margin-top: 15%; text-align: center;">
                    <h1>什么都没有找到</h1>
                    <div>
                        没有可以查看的动态信息！！！
                    </div>
                </el-col>
                <el-col :span="14">
                    <img src="../../../assets/images/empty.gif">
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { getArticle } from '@/api/api'

export default {
    name: 'evaluationModal',
    props: {
        articleId: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            loading: false,
            text: null
        }
    },
    watch: {
        articleId: {
            immediate: true,
            handler (val) {
                if (this.articleId) {
                    this.loadData()
                }
            }
        }
    },
    created () {
        this.loading = true
    },
    methods: {
        loadData () {
            getArticle({articleId: this.articleId}).then(res => {
                if (res.data.success) {
                    let result = res.data.result
                    if (result && result.body) {
                        this.text = this.unescape(result.body)
                    } else {
                        this.text = ''
                    }
                }
            }).finally(() => {
                this.loading = false
            })
        },
        unescape (html) {
            return html.replace(html ? /&(?!#?\w+;)/g : /&/g, '&amp;')
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>')
                .replace(/&quot;/g, '"')
                .replace(/&#39;/g, '\'')
                .replace(/l&amp;nbsp;/g, '\u00A0')
                .replace(/&amp;nbsp;/g, '\u00A0')
        }
    }
}
</script>

<style scoped>
    .contentBody{
        min-height: 50vh;
    }
</style>



// WEBPACK FOOTER //
// src/views/appraise/modules/evaluationModal.vue